import { useConfig } from '@kega/sps-core';
import { Helmet } from 'react-helmet-async';
import { connectStateResults } from 'react-instantsearch-dom';

import useTranslatePath from '../../../hooks/useTranslatePath';

const CanonicalLinks = ({ url, searchResults }) => {
    const config = useConfig();

    const { nbHits=0, hitsPerPage=0, page=0 } = searchResults ?? {};

    const totalPages = hitsPerPage > 0 ? Math.ceil(nbHits / hitsPerPage) : 0;
    
    const baseUrl = config.get('baseUrl');
    const { getPath } = useTranslatePath();
    
    const path = getPath(url);
    const effectiveUrl = !url && path ? '/search' : url;
    
    const searchParams = typeof window !== 'undefined' 
        ? new URLSearchParams(window.location.search) 
        : new URLSearchParams();
    
    const createUrlWithParams = (pageNum) => {
        const params = new URLSearchParams(searchParams);
        
        if (pageNum > 1) {
            params.set('page', pageNum);
        } else {
            params.delete('page');
        }
        
        const queryString = params.toString();
        return `${baseUrl}${getPath(effectiveUrl)}${queryString ? `?${queryString.toString()}` : ''}`;
    };
    
    return (
        <Helmet>
            <link rel="canonical" href={createUrlWithParams(page > 0 ? page + 1 : 1)} />
            {page > 0 && (
                <link rel="prev" href={createUrlWithParams(page)} />
            )}
            {page + 1 < totalPages && (
                <link rel="next" href={createUrlWithParams(page + 2)} />
            )}
        </Helmet>
    )
}

export default connectStateResults(CanonicalLinks);